import { FiledTarget, MailAddress } from './mail-upload.models';

/** What the filing request takes from the mail itself, next to its EML. */
export interface MailMetadata {
  subject: string;
  absender: MailAddress;
  empfaenger: MailAddress[];
  cc: MailAddress[];
  gesendetDatum: string | null;
  /** When the sender sent the mail, ISO. For placeholders only, never sent; null where unknown. */
  sentDateTime: string | null;
}

/**
 * One mail that can be filed, whichever way it is read and written: the mail
 * open in Outlook through Office.js, or a selected one through another API.
 */
export interface FilingSource {
  readonly id: string;
  getMetadata(): Promise<MailMetadata>;
  /** Where the mail has been filed so far, newest first. */
  getFilings(): Promise<FiledTarget[]>;
  /** The mail as a base64 RFC-822 EML. */
  getEmlBase64(): Promise<string>;
  /** Adds a filing to the record on the mail. */
  recordFiling(target: FiledTarget): Promise<void>;
  /** Puts the CMI category on the mail. */
  markFiled(): Promise<void>;
}

/**
 * Raised by a source whose mail is no longer the one it was taken from, so
 * what it read belongs to another mail than the one the user filed.
 */
export class MailChangedError extends Error {}
